module.exports = __webpack_public_path__ + "img/tattoo-camomile-6w4jeanfs.jpg";